import { patchRequest } from '@/core';
import { orders } from '@/requests';

export default async function updateOrderRequest(id, patch) {
	let url = orders.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
